import { render, staticRenderFns } from "./uploaderInvoice.vue?vue&type=template&id=fc5e64ec&scoped=true&"
import script from "./uploaderInvoice.vue?vue&type=script&lang=ts&"
export * from "./uploaderInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./uploaderInvoice.vue?vue&type=style&index=0&id=fc5e64ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5e64ec",
  null
  
)

export default component.exports